import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import {Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'

import Pagination from "../../services/Pagination";
import { Table, Form } from 'react-bootstrap'


import ModalAgregarArticulo from './ModalAgregarArticulo'
import ModalEditarArticulo from './ModalEditarArticulo'


const ModalProveedorListaArticulos = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, proveedor } = params


  const [allSessionsCount,setCounter] = useState(0);
  const sessionsPerPage = 10
  const [currentPage, setCurrentPage] = useState(1);

  const [ text_busqueda, setTextoBusqueda ] = useState('')

  const [ cargando_, setCargando ] = useState( true )

  const skull = { results: [] }

  const [ resultados, setResultados ] = useState<any>({...skull})

  const cargarMiReporte = async(page:number)=>{
    try{
      setCargando(true)
      let skip = 0
      if(page===0) skip = 0; else skip = (page*10);
      let response : any = await RequestService.getEndPoint(`proveedor/listado_articulos/${proveedor.uuid}/busqueda?where=${text_busqueda}&skip=${skip}`)
      setCounter(response.data.totalCount)
      setResultados(response.data.resultados)
      setCargando(false)
    }
    catch(e){
      setCargando(false)
      toast.error('Problemas al intentar cargar tus resultados')
    }
  }


  const busqueda = async () =>{
    cargarMiReporte(0)
    setCurrentPage(1)
  }

      React.useEffect(() => {
        cargarMiReporte(0)
      }, []);




  const [ show_ModalAgregarArticulo, setModalAgregarArticulo ] = useState<boolean>(false)
  const handleShow_ModalAgregarArticulo = () => {
    setModalAgregarArticulo(true)
  }
  const handleClose_ModalAgregarArticulo = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalAgregarArticulo(false)
  }






  const [ articulo_seleccionado, setArticuloSeleccionado ] = useState<any>({})
  const [ show_ModalEditarArticulo, setModalEditarArticulo ] = useState<boolean>(false)
  const handleShow_ModalEditarArticulo = (articulo:any) => {
    setArticuloSeleccionado(articulo)
    setModalEditarArticulo(true)
  }
  const handleClose_ModalEditarArticulo = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalEditarArticulo(false)
  }


  return (
    <>
      <Modal show={show} size="xl" onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Listado de Artículos del Proveedor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {

          }


          <ul className="list-inline">
            <li className="list-inline-item"><small className="pointer" onClick={()=>{handleShow_ModalAgregarArticulo()}}>Agregar Artículo</small></li>
          </ul>


                          {  (!cargando_) && (

                              <>

                                   {
                                     resultados.length > 0 && (

                                       <>


                                       <h5>Resultados</h5>


                                        <Table hover responsive="lg">
                                          <thead style={{fontSize:10}}>
                                            <tr>
                                              <th scope="col">Tipo</th>
                                              <th scope="col">Unidad de Medida</th>
                                              <th scope="col">Artículo</th>
                                              <th scope="col">$ Proveedor</th>
                                              <th scope="col">$ Cliente</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {


                                              resultados.map( (cual:any,indice:number) =>
                                                  <tr key={ Math.random().toString(36).substr(2, 9) } style={{fontSize:12}}>
                                                    <td className="v text-left" style={{"width":"160px"}}>
                                                        <p className="nm"><b>{cual.idtipo_articulo.tipo_articulo}</b></p>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"160px"}}>
                                                        <p className="nm"><b>{cual.idunidad_medida.unidad_medida}</b></p>
                                                    </td>
                                                    <td className="v text-left">
                                                        <p className="nm"><small><b>{cual.articulo}</b></small></p>
                                                        <small>{cual.descripcion}</small>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"100px"}}>
                                                        <p className="nm"><b>$ {cual.precio}</b></p>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"100px"}}>
                                                        <p className="nm"><b>$ {cual.costo}</b></p>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"40px"}}>
                                                        <Button onClick={(e:any)=>{handleShow_ModalEditarArticulo(cual)}} size="sm" variant="warning"><i className="fa fa-edit"/></Button>
                                                    </td>
                                                  </tr>
                                               )
                                            }

                                          </tbody>
                                        </Table>


                                          <Pagination
                                            itemsCount={allSessionsCount}
                                            itemsPerPage={sessionsPerPage}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            cambiarPaginaEvento={cargarMiReporte}
                                            alwaysShown={false}
                                          />


                                        </>



                                       )
                                     
                                   }


                              </>

                           )}

                          {  cargando_ && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}

        </Modal.Body>
      </Modal>


  {
    show_ModalAgregarArticulo && (
      <ModalAgregarArticulo show={show_ModalAgregarArticulo} handleClose={handleClose_ModalAgregarArticulo} proveedor={proveedor} />
      )

  }


  {
    show_ModalEditarArticulo && (
      <ModalEditarArticulo show={show_ModalEditarArticulo} handleClose={handleClose_ModalEditarArticulo} articulo={articulo_seleccionado} panel_proveedor={true} />
      )

  }

    </>
  );
}


export default ModalProveedorListaArticulos;